import { useEffect, useState } from 'react';
import { getDeviceType } from '../../utils/getDeviceType';
import Modal from '../Modal';
import Button from '../Button/Button';
import { messages } from './messages';
import Input from '../Input/Input';

const getPwaInstalled = () => {
  return (
    (window.navigator as any).standalone ||
    window.matchMedia('(display-mode: standalone)').matches
  );
};
const AddToHomeScreenPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [deviceType, setDeviceType] = useState<
    ReturnType<typeof getDeviceType> | undefined
  >(undefined);
  const appInstalled =
    getPwaInstalled() || localStorage.getItem('pwaInstalled') === 'true';
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const isPromptedEnabled =
    (localStorage.getItem('showPWAPrompt') !== 'false' &&
      sessionStorage.getItem('showPWAPrompt') !== 'false') ??
    true;
  useEffect(() => {
    window.addEventListener('appinstalled', () => {
      localStorage.setItem('pwaInstalled', 'true');
    });
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    setTimeout(() => {
      setShowPrompt(true);
      const d = getDeviceType();
      setDeviceType(d);
    }, 30000);

    if (isPromptedEnabled)
      window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((_: any) => {
        setDeferredPrompt(null);
        setShowPrompt(false);
      });
    } else {
      localStorage.setItem('pwaInstalled', 'true');
      setDeferredPrompt(null);
      setShowPrompt(false);
    }
  };

  return (
    <>
      {isPromptedEnabled && !appInstalled && deviceType !== 'firefox' && (
        <Modal
          isActive={showPrompt}
          title={messages.pwa}
          onClose={() => {
            setShowPrompt(false);

            if (dontShowAgain) localStorage.setItem('showPWAPrompt', 'false');
            else sessionStorage.setItem('showPWAPrompt', 'false');
          }}
          width={'auto'}
          height={deviceType !== 'ios' ? 'auto' : '90%'}
        >
          <div className="h-full flex flex-col justify-between">
            <div>
              {(deviceType === 'android' || deviceType === 'desktop') && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: '20px',
                  }}
                >
                  <p>{messages.addToHomeScreen}</p>
                  <Button
                    type="button"
                    color="black"
                    onClick={handleInstallClick}
                  >
                    {messages.add}
                  </Button>
                </div>
              )}
              {deviceType === 'ios' && (
                <>
                  <p>
                    {messages.addToHomeScreen}:
                    <br />
                  </p>
                  <div className="flex flex-col gap-5">
                    {messages.iosStep1}
                    <img
                      alt="Press share button"
                      src="/assets/PWA/iphone/iphone-1.jpeg"
                      style={{ height: '50vh', objectFit: 'contain' }}
                    />
                    {messages.iosStep2}
                    <img
                      alt="Navigate down and choos Add to Home Screen"
                      src="/assets/PWA/iphone/iphone-2.jpeg"
                      style={{ height: '50vh', objectFit: 'contain' }}
                    />
                    {messages.iosStep3}
                    <img
                      alt="Press add"
                      src="/assets/PWA/iphone/iphone-3.jpeg"
                      style={{ height: '50vh', objectFit: 'contain' }}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="py-3">
              <Input
                id={'notShowPrompt'}
                label={messages.dontShowAgain}
                type="checkbox"
                checked={dontShowAgain}
                onClick={(e: any) => {
                  setDontShowAgain(e.target.checked);
                }}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AddToHomeScreenPrompt;
